import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

// Shared layout so the More Options button lines up across mixed-status grids:
// every row is [action icon][indicator slot][more], with the slot empty when there is no indicator.
export function RequestActionsRow({ children }: PropsWithChildren) {
  return (
    <Stack direction='row' justifyContent='start' alignItems='center' width='100%'>
      {children}
    </Stack>
  );
}

export function ActionIndicatorSlot({ title, children }: PropsWithChildren<{ title?: string }>) {
  return (
    <Stack width='1.3rem' height='100%' alignItems='center' justifyContent='center' title={title}>
      {children}
    </Stack>
  );
}
